export const faqs = [
  {
    question: '黑料雷达的内容从哪里来？会不会有未经证实的指控？',
    answer:
      '站内事件以公开信息为基础整理，优先采信监管通报、厂商公开说明与可验证的安全研究报告。对于尚未有官方确认的线索，我们会明确标注「待核实」，不以结论性语气呈现。',
  },
  {
    question: '怎么判断一个平台是不是高风险？',
    answer:
      '可以从四个角度快速判断：是否出现过公开通报或处罚记录、隐私政策是否说清数据用途与撤回方式、是否默认开启营销类共享或免密代扣、以及出问题后是否有对外可用的响应渠道。四项里有两项以上存疑，就建议谨慎授权。',
  },
  {
    question: '我发现自己的信息可能已经泄露了，第一步该做什么？',
    answer:
      '先止损再追溯：修改该账号密码（不要与其他账号重复），开启双重验证，检查支付工具里的免密代扣并在必要时更换绑定卡片。随后留意异常来电与短信，短期内对「能准确报出你信息」的来电保持高度警惕。',
  },
  {
    question: '删除应用是不是就等于取消订阅和授权了？',
    answer:
      '不是。卸载只清理本地客户端，服务端的代扣授权与账号授权仍然有效。正确顺序是：先在支付工具里取消自动续费，再到平台账号内注销或撤回授权，最后才删除应用。',
  },
  {
    question: '我可以向你们提供线索或报料吗？',
    answer:
      '可以。我们欢迎来自用户的一手经历、漏洞线索与通报信息。报料时建议提供时间、平台类型与可验证的截图，我们会对提供者身份做匿名处理，并在核实后决定是否公开。',
  },
  {
    question: '你们会对被点名的平台做删稿处理吗？',
    answer:
      '如果平台提供了足以推翻原始结论的官方说明或第三方证据，我们会更正内容并标注更新记录。单纯的商务沟通不影响内容判断，这是我们维持可信度的底线。',
  },
];

export const principles = [
  {
    icon: 'ri-search-eye-line',
    title: '公开信息优先',
    description: '每条事件都尽量追溯到可查证的信息来源，而不是依赖匿名转述。',
  },
  {
    icon: 'ri-scales-3-line',
    title: '克制用语',
    description: '区分「已确认」与「待核实」，不把推测写成结论，不做情绪化指控。',
  },
  {
    icon: 'ri-refresh-line',
    title: '可更正',
    description: '当出现新证据时主动更正内容，并保留更新记录便于读者追溯。',
  },
  {
    icon: 'ri-shield-user-line',
    title: '保护报料人',
    description: '对线索提供者做匿名处理，未经同意不披露任何可识别身份的信息。',
  },
];

export const voices = [
  {
    quote:
      '看你们的整理之前，我一直以为「只泄露了个手机号」没什么。直到真的接到能报出订单号的电话，才知道问题出在哪。',
    name: '周先生',
    role: '自由职业者',
  },
  {
    quote: '合规检查前先来这儿检索了一圈，比翻各家隐私政策效率高太多，措辞也很克制，不会一上来就下结论。',
    name: '林女士',
    role: '小微企业主',
  },
  {
    quote: '免密代扣那篇让我在支付工具里翻出三个忘了取消的订阅，一年省了小两百，属于意外收获。',
    name: '陈同学',
    role: '在读研究生',
  },
];

export const siteStats = [
  { value: '1,280+', label: '收录事件与通报' },
  { value: '6', label: '风险类别' },
  { value: '48h', label: '平均核查响应' },
  { value: '2021', label: '持续整理至今' },
];

export const contactInfo = {
  brand: '黑料雷达',
  tagline: '聚焦安全事件与隐私风险的中文情报站',
  email: 'report@heiliaoleida.com',
  cooperativeEmail: 'contact@heiliaoleida.com',
  workingHours: '工作日 10:00 - 18:00（节假日顺延）',
  responseTime: '报料核查通常在 48 小时内给出初步回复',
};